// Must stay the first import: registering the Trusted Types policy has to happen before any
// code path can inject a script, and the dynamic import of './bootstrap' below is the first
// one that does.
import 'src/trustedTypes/trustedTypesPolicy';
// Must also precede the './bootstrap' import: three remote MFEs (MyHRLiveHelpModuleWebsite,
// AtoZAssistantComponent, AtoZAssistantComponentForEveryone) fetch SystemJS from a public CDN
// on mount unless window.System is already set, which this sets as a side effect.
import 'systemjs/dist/system.min.js';
// Must also precede the './bootstrap' import: Zod's JIT probe runs `new Function` when the
// first schema is constructed, and `@json-render/core` constructs schemas at module load.
import 'src/zodConfig';
import { STAGE } from 'src/constants/StageConfig';
import { getCurrentStage } from 'src/utils/StageConfigUtils';
import { ContainerAppName, setRemoteEntryFileUrlWindowAttributes } from '@amzn/employee-support-central-mfe-config';

if (getCurrentStage() === STAGE.PROD || getCurrentStage() === STAGE.ONEBOX) {
  window['FAB_URL'] = 'https://fab.myhr.a2z.com';
  window['WORKFLOW_URL'] = 'https://atoz-khonsu-workflow-rendering-app.amazon.work';
  window['KHONSU_URL'] = 'https://wui.prod.khonsu.pxt.amazon.dev';
} else {
  window['FAB_URL'] = 'https://beta.fab.myhr.a2z.com';
  window['WORKFLOW_URL'] = 'https://atoz-khonsu-workflow-rendering.integ.amazon.work';
  window['KHONSU_URL'] = 'https://wui.gamma.khonsu.pxt.amazon.dev';
}

setRemoteEntryFileUrlWindowAttributes(window, ContainerAppName.HRSC);

import('./bootstrap');

export {};
